module.exports = __webpack_public_path__ + "static/img/img-1.a9b1b2a3.png";